module.exports = __webpack_public_path__ + "img/pm_2.d83aa5b2.png";